import { useState, useMemo } from "react"
import { Calendar, Clock, Plus, X, ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../../ui/button"
import { Checkbox } from "../../ui/checkbox"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select"
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card"
import { Calendar as CalendarComponent } from "../../ui/calendar"
import { Badge } from "../../ui/badge"
import { Row, Col, Input, Tabs, Form } from '../../ui/ot'
import OpeningHoursManagementForm from "./opening_hours_management_form"
import { useEffect } from "react"
const OpeningHoursManagement = ({

}) => {
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue({
            schedule_data: [
                { name: "星期一", timeSlots: [{ startTime: "08:00", endTime: "20:00", isOpen: true }] },
                { name: "星期二", timeSlots: [{ startTime: "08:00", endTime: "20:00", isOpen: true }] },
                { name: "星期三", timeSlots: [{ startTime: "08:00", endTime: "20:00", isOpen: true }] },
                { name: "星期四", timeSlots: [{ startTime: "08:00", endTime: "20:00", isOpen: true }] },
                { name: "星期五", timeSlots: [{ startTime: "08:00", endTime: "20:00", isOpen: true }] },
                { name: "星期六", timeSlots: [{ startTime: "09:00", endTime: "17:00", isOpen: true }] },
                { name: "星期日", timeSlots: [{ startTime: "09:00", endTime: "17:00", isOpen: true }] },
              ],
        })
    }, [])
    return (<Row>
        <Col span={24}>
            <OpeningHoursManagementForm
                propsForm={form}
            />
        </Col>
    </Row>)
}
export default OpeningHoursManagement